<template>
  <svg
    class="custom-icon"
    width="18"
    height="10"
    viewBox="0 0 18 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.48212 9.50009L0.866116 5.88411C0.37796 5.39596 0.37796 4.6045 0.866116 4.11635L4.48212 0.500346C4.97027 0.0121908 5.76173 0.0121908 6.24988 0.500346C6.73804 0.988502 6.73804 1.77996 6.24988 2.26811L4.76777 3.75023L16.25 3.75014C16.9404 3.75014 17.5 4.30979 17.5 5.00014C17.5 5.6905 16.9404 6.25014 16.25 6.25014L4.76777 6.25023L6.24988 7.73233C6.73804 8.22048 6.73804 9.01194 6.24988 9.50009C5.76173 9.98825 4.97027 9.98825 4.48212 9.50009Z"
    />
  </svg>
</template>
